<template>
  <v-menu
    offset-y
    full-width
    v-model="menu"
    :close-on-content-click="false"
    nudge-top="24"
  >
    <v-text-field
      :label="label"
      :hint="hint"
      slot="activator"
      v-model="value.name"
      append-icon="arrow_drop_down"
      readonly
      :rules="rules"
    >
    </v-text-field>
    <v-card>
      <v-form v-model="formValid" ref="formRef">

        <v-card-text>
          <v-checkbox
            label="1. 如果该人员属于本系统用户，请检索并选择。"
            v-model="userType"
            value="sys"
            class="blue--text body-2"
            hide-details
          />
          <v-autocomplete
            autofocus
            label="系统用户"
            item-text="name"
            item-value="dbid"
            autocomplete
            clearable
            required
            :rules="XRules.sysUser"
            :loading="userLoading"
            :items="userItems"
            :search-input.sync="nameSearch"
            v-model="sysUser"
            :return-object="true"
            hint="输入关键词，选择系统内的用户。"
            persistent-hint
            :disabled="userType !== 'sys'"
          >
            <!--
            @keyup.enter="onNameSearch"
            -->
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{data.item.name}}{{formatTitle(data.item.title)}}{{formatAge(data.item.birthday)}}
                </v-list-tile-title>
                <v-list-tile-sub-title>{{formatDept(data.item.deptRoles)}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>

          <v-checkbox
            label="2. 如果该人员不属于本系统用户，请填写姓名。"
            v-model="userType"
            value="oth"
            class="blue--text body-2"
            hide-details
          />
          <v-text-field
            label="系统外人员"
            required
            :rules="XRules.othUser"
            v-model="othUser"
            hint="输入外单位人员姓名，或系统外的人员。"
            persistent-hint
            :disabled="userType !== 'oth'"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="menu = false">取消</v-btn>
          <v-btn color="primary" @click="onOk">确定</v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-menu>

</template>
<script>
  export default {
    props: ['value', 'label', 'hint', 'rules'],

    data() {
      return {
        userURI: '/api/syst/user/search',

        menu: false,
        formValid: true,

        userType: 'sys',
        sysUser: {
          userId: null,
          name: null,
          deptName: null
        },
        othUser: null,

        userLoading: false,
        userItems: [],

        nameSearch: '',

        XRules: {
          required: [
            v => (!this.menu || !!v) || '必填项。'
          ],
          sysUser: [
            v => (this.userType !== 'sys' || !!v) || '必填项。'
          ],
          othUser: [
            v => (this.userType !== 'oth' || !!v) || '必填项。'
          ]
        }
      }
    },
    watch: {
      nameSearch(val) {
        val && val.length && this.onNameSearch();
      },

      "userType": function (nv) {
        //console.log(nv);
        if (nv === 'sys') {
          this.othUser = null;
        } else {
          this.sysUser =
            {
              userId: null,
              name: null,
              deptName: null
            }
        }
      }
    },

    methods: {
      onNameSearch() {
        const vm = this;
        const param = window.xutil.param("name", this.nameSearch);

        vm.userLoading = true;
        this.axios.get(vm.userURI, {params: param})
          .then(
            rsp => {
              vm.userLoading = false;
              vm.userItems = rsp.data.items
            })
      },

      onOk() {
        window.console.log("in onOk");
        if (this.$refs.formRef.validate()) {
          if (this.userType === 'sys') {
            window.console.log(this.sysUser);
            const dept = this.sysUser.deptRoles ? this.sysUser.deptRoles[0].department : {};
            this.$emit('input', {
              userId: this.sysUser.dbid,
              name: this.sysUser.name,
              number: this.sysUser.number,

              deptId: dept.dbid || "",
              deptName: dept.name || "",

              email: this.sysUser.email,
              phone: this.sysUser.phone,

              titleId: this.sysUser.titleId,
              titleName: this.sysUser.title ? this.sysUser.title.name : ''
            });
          }
          else {
            this.$emit('input', {
              userId: null,
              name: this.othUser,
              deptId: null,
              deptName: null
            });
          }

          this.menu = false;
          this.othUser = null;
          this.sysUser = {userId: null, name: null, deptName: null};
          this.$refs.formRef.reset();
        }
      },

      formatAge(birthday) {
        let age = null;
        if (birthday) {
          age = new Date(new Date() - new Date(birthday)).getFullYear() - 1970;
        }
        return age ? ` / ${age}岁` : '';
      },

      formatTitle(title) {
        return title ? ` / ${title.name}` : '';
      },

      formatDept(deptRoles) {
        return (deptRoles || []).map(dr => dr.department.name).unique().join(", ");
      }
    }

  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

